import { ChangeDetectionStrategy, Component, Input } from "@angular/core";


/**
 * Form field wrapper. Composes label + control slot + hint/error.
 *
 * Setting `error` to a non-empty string both renders the error message
 * and toggles a `data-error` attribute on the host — global form
 * styles in src/styles/forms.scss watch for that attribute and apply
 * error border + focus ring to any `bv-input` inside.
 *
 *   <bv-form-field label="Email" hint="We won't share." [error]="emailError">
 *     <input bv-input type="email" [(ngModel)]="email" />
 *   </bv-form-field>
 */
@Component({
    selector: "bv-form-field",
    templateUrl: "./form-field.component.html",
    styleUrls: ["./form-field.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: "bv-form-field",
        "[attr.data-error]": "error ? '' : null",
    },
    imports: []
})
export class BvFormFieldComponent {
  @Input() label?: string;
  @Input() hint?: string;
  @Input() error?: string | null;
}
